<template>
	<div class="bg-gray">
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`">
				<div class="container">
					<h2 class="text-white"></h2>
					<p class="text-white"></p>
				</div>
			</div>
		</div>
		<div class="container">
			<div class="top-area">
				<router-link :to="{path:'/roadshow/list',query:{menuPosition:menuPosition,queryName:item.roadshowType,roadshow:item.id}}" v-for="(item,index) in typeList" :key="index">
					<div class="item active" @mouseover="changeType(index)" @mouseleave="removeType"
						v-if="currentType==index"
						:style="`background: url(${imgPath+item.pcBackground}) no-repeat;backgroundSize:100% 100%;`">
						<div class="icon-box"><img :src="imgPath+item.pcIconTrue" alt=""></div>
						<div class="title">{{item.roadshowType}}</div>
						<div class="content">{{item.roadshowContent}}</div>
						<div class="line"></div>
					</div>
					<div class="item" @mouseover="changeType(index)" @mouseleave="removeType" v-else>
						<div class="icon-box"><img :src="imgPath+item.pcIconFalse" alt=""></div>
						<div class="title">{{item.roadshowType}}</div>
						<div class="content">{{item.roadshowContent}}</div>
						<div class="line"></div>
					</div>
				</router-link>
			</div>

			<div class="card">
				<div class="card-head">
					<div class="title">
						<div class="line"></div>活动预告
					</div>
					<div>
						<a-select v-model="choosedYear" style="width: 100px" @change="chooseYear">
							<a-select-option v-for="(item,index) in yearList" :key="item.value" :value="item.value">
								{{item.text}}
							</a-select-option>				
						</a-select>
						<a-select v-model="choosedMonth" style="width: 80px" @change="chooseMonth">
							<a-select-option v-for="(item,index) in monthList" :key="item.value" :value="item.value">
								{{item.text}}
							</a-select-option>					
						</a-select>
						<a-button-group>
							<a-button @click="preWeek"> < </a-button>
							<a-button @click="nextWeek"> > </a-button>
						</a-button-group>
					</div>
				</div>
				<div class="card-body">
					<Calendar ref="calendar" :list="timesList" @click="dateChange" :position="menuPosition"></Calendar>
					<div class="road-info" v-if="hasNearList" @click="toJump(nearList.records[currentIndex].id)">
						<img class="thumb" :src="imgPath+nearList.records[currentIndex].pcImageUrl" alt="">
						<div class="info-box">
							<div class="title-box">
								<span class="title">{{nearList.records[currentIndex].roadshowTitle}}</span>
								<div class="tips" v-if="nearList.records[currentIndex].status==0">预约中</div>
								<div class="tips-end" v-if="nearList.records[currentIndex].status==-1">已结束</div>
								<div class="tips" v-if="nearList.records[currentIndex].status==1">进行中</div>
							</div>
							<div class="descs">
								{{nearList.records[currentIndex].content||''}}
							</div>
							<div class="time">
								<div class="icon"><img src="@/assets/road_time.png" alt=""></div>
								<div class="time-info">
									<div class='color-999'>直播时间</div>
									<div class="color-1a margin-top-10">{{nearList.records[currentIndex].beginTime}} — {{nearList.records[currentIndex].endTime}}</div>
								</div>
							</div>
							<div class="company">
								<div class="icon"><img src="@/assets/road_danwei.png" alt=""></div>
								<div class="company-info">
									<div class='color-999'>主办单位</div>
									<div class="color-1a margin-top-10">{{nearList.records[currentIndex].organizer}}</div>
								</div>
							</div>
							<div class="anchor">
								<div><span class="font-24">{{currentIndex+1}}</span><span> / {{nearList.records.length}}</span></div>
								<div class="flex">
									<img style="cursor: pointer;" width="25" @click.stop="changeRoadShow('pre')" height="25" src="@/assets/banner_to_left.png" alt="">
									<img style="cursor: pointer;" width="25" @click.stop="changeRoadShow('next')" height="25" src="@/assets/banner_to_right.png" alt="">
								</div>
							</div>
						</div>
					</div>
					<div class="padding-10 margin-top-30" v-else>
						<a-empty :description="false" />
					</div>
				</div>
			</div>

			<div class="card">
				<div class="card-head">
					<div class="title">
						<div class="line"></div>往期活动
					</div>
					<div>
						<div>
							<a @click="prevLink"><img src="@/assets/friend_left.png" alt=""></a>
							<a @click="nextLink" style="margin-left:10px;"><img src="@/assets/friend_right.png"></a>
						</div>
					</div>
				</div>
				<div class="card-body">
					<a-carousel style="width: 100%;" :dots="false" ref="friendCarousel">
						<div v-for="(item,index) in oldRoadList">
							<div class="flex justify-between">
								<router-link :to="{path:'/roadshow/last',query:{menuPosition:menuPosition,lastShow:child.id}}" v-for="(child,childIndex) in item" :key="childIndex">
									<div class="act-item"
										:style="`background: url(${imgPath+child.pcBackground}) no-repeat;backgroundSize:100% 100%;`">
										<div class="bg">
											<div class="title">
												<span>{{child.roadshowActivity}}</span>
											</div>
										</div>
									</div>
								</router-link>
							</div>
						</div>
					</a-carousel>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Calendar from "@/components/Calendar/Calendar"
	export default {
		components: {
			Calendar
		},
		data() {
			return {
				headBg: "",
				menuPosition: "",
				typeList: [],
				imgPath: "",
				currentType: "null",
				oldRoadList: [],
				yearList:[], //年
				monthList:[],  //月
				choosedYear:new Date().getFullYear(),
				choosedMonth:new Date().getMonth()+1,
				nearList:'', //最近活动列表
				hasNearList:false,
				currentIndex:0,  //最近活动索引
				date:[],
				timesList:"",
			}
		},
		mounted() {
			document.title = "雄安股权交易所-培训路演";
			this.menuPosition = this.$route.query.menuPosition;
			this.imgPath = this.$api.baseUrl + this.$api.imgPath;
			let _date = this.$refs.calendar.initData(null);
			this.date = _date.date;
			this.getHeadBanner();
			this.getRoadShowTypes();
			this.getOldRoadList();
			this.getNearRoadList();
			this.queryCalendar();
		},
		created(){
			this.createYear();
			this.createMonth();
		},
		methods: {
			dateChange(data){
				this.date = data;
				this.queryCalendarNear();
			},
			toJump(id){
				this.$router.push({path:'/roadshow/info',query:{menuPosition:this.menuPosition,roadshow:id}});
			},
			changeRoadShow(type){
				if(type=='pre'){
					if(this.currentIndex>0){
						this.currentIndex--;
					}
				}else{
					if(this.currentIndex<this.nearList.total-1){
						this.currentIndex++;
					}
				}
			},
			// 上周
			preWeek(){
				let date  = this.$refs.calendar.weekPre()
				this.date = date.date;
				this.choosedYear = date.year;
				this.choosedMonth = date.month;
				this.queryCalendar();
			},
			// 下周
			nextWeek(){
				let date = this.$refs.calendar.weekNext()
				this.date = date.date;
				this.choosedYear = date.year;
				this.choosedMonth = date.month;
				this.queryCalendar();
			},
			chooseYear(value){
				this.choosedYear = value
				let _date = this.$refs.calendar.pickNext(this.choosedYear,this.choosedMonth)
				this.date = _date.date;
				this.queryCalendar();
			},
			chooseMonth(value){
				this.choosedMonth = value
				let _date = this.$refs.calendar.pickNext(this.choosedYear,this.choosedMonth)
				this.date = _date.date;
				this.queryCalendar();
			},
			queryCalendar(){
				this.$request({
					url:this.$api.roadshow.queryCalendar,
					data:{
						times:this.date.toString()
					}
				}).then((res)=>{
					this.timesList = res.data.result;
					console.log(this.timesList);
				})
			},
			queryCalendarNear(){
				this.$request({
					url:this.$api.roadshow.queryCalendar,
					data:{
						times:this.date.toString()
					}
				}).then((res)=>{
					this.nearList = {records:[],total:0};
					this.nearList.records = res.data.result[0][this.date];
					this.nearList.total = res.data.result[0][this.date].length;
					this.nearList.records.forEach((item)=>{
						item.status = this.checkStatus(item.beginTime,item.endTime)
					});
					this.hasNearList = this.nearList.total>0?true:false;
				})
			},
			// 顶部背景
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: this.menuPosition,
						type:1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
			//获取近期活动
			getNearRoadList(){
				this.$request({
					url:this.$api.roadshow.queryRoadshowDetailsList,
				}).then((res)=>{
					this.nearList = res.data.result;
					this.nearList.records.forEach((item)=>{
						item.status = this.checkStatus(item.beginTime,item.endTime)
					});
					
					this.hasNearList = this.nearList.total>0?true:false;
				})
			},
			checkStatus(begin,end){
				let beginDate = new Date(begin);
				let endDate = new Date(end);
				let now = new Date();
				let status;
				if(now < beginDate){
					status = 0;
				}else if(now >= beginDate && now < endDate){
					status = 1;
				}else{
					status = -1;
				}
				
				return status;
			},
			// 获取往期活动
			getOldRoadList() {
				this.$request({
					url: this.$api.roadshow.getOldRoadList
				}).then((res) => {
					let _result = res.data.result;
					let _count = 2;
					let _friendArr = [];
					for (var i = 0, j = _result.length; i < j; i += _count) {
						_friendArr.push(_result.slice(i, i + _count));
					}
					this.oldRoadList = _friendArr;
				})
			},
			// 获取分类
			getRoadShowTypes() {
				this.$request({
					url: this.$api.roadshow.getRoadShowTypes
				}).then((res) => {
					this.typeList = res.data.result;
				})
			},
			changeType(index) {
				this.currentType = index;
			},
			removeType() {
				this.currentType = "null";
			},
			prevLink() {
				this.$refs.friendCarousel.prev()
			},
			nextLink() {
				this.$refs.friendCarousel.next()
			},
			// 生成年数组
			createYear(){
				let year = 2000;
				this.yearList = [];
				for(let i = 2000;i<2100;i++){
					year ++;
					this.yearList.push({value:year,text:year+"年"});
				}
			},
			// 生成月
			createMonth(){
				let month = 0;
				this.monthList = [];
				for(let i = 0;i<12;i++){
					month++;
					this.monthList.push({value:month,text:month+"月"})
				}
			},
		}
	}
</script>

<style scoped>
	.card {
		background-color: #fff;
		border-radius: 8px;
		padding: 20px;
		margin-top: 30px;
	}

	.card .card-head {
		display: flex;
		justify-content: space-between;
		align-items: center;
	}

	.card .card-head .title {
		color: #1A1A1A;
		font-size: 24px;
		font-weight: 500;
		display: flex;
		align-items: center;
	}

	.card .card-head .line {
		width: 4px;
		height: 24px;
		margin-right: 10px;
		background: linear-gradient(180deg, #1E22AA 0%, #0CB2EC 100%);
	}

	.card:last-of-type {
		margin-bottom: 30px;
	}

	.top-area {
		display: flex;
		flex-flow: row nowrap;
		justify-content: space-between;
		margin-top: -70px;
	}

	.top-area .item {
		position: relative;
		width: 380px;
		height: 255px;
		padding: 30px;
		background-color: white;
		border-radius: 8px;
		cursor: pointer;
	}

	.top-area .item .icon-box {
		width: 50px;
		height: 50px;
	}

	.top-area .item .icon-box img {
		width: 50px;
		height: 50px;
	}

	.top-area .item .title {
		font-size: 24px;
		font-weight: 500;
		color: #1A1A1A;
		margin-top: 16px;
	}

	.top-area .active .title {
		color: #13B8EE;
	}

	.top-area .item .content {
		margin-top:16px;
		font-size: 16px;
		font-weight: 400;
		color: #666666;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 3;
		-webkit-box-orient: vertical;
	}

	.top-area .active .content {
		color: #13B8EE;
	}

	.top-area .item .line {
		width: 48px;
		height: 6px;
		background: #fff;
		border-radius: 0px 0px 6px 6px;
		position: absolute;
		top: 0;
	}

	.top-area .active .line {
		background: #13B8EE;
	}

	.bg-gray {
		background: #F6F7FC;
	}

	.road-info {
		display: flex;
		margin-top: 33px;
		border: 1px solid #E6E6E6;
		cursor: pointer;
	}

	.road-info .thumb {
		min-width: 642px;
		height: 361px;
		object-fit:cover;
	}

	.road-info .info-box {
		padding: 40px;
		/* width: 680px; */
		position: relative;
	}

	.road-info .anchor {
		position: absolute;
		bottom: 30px;
		width: 380px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.road-info .info-box .title-box {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.road-info .info-box .title-box .title {
		width:390px;
		font-size: 24px;
		font-weight: 500;
		color: #1A1A1A;
	}

	.road-info .info-box .title-box .tips {
		width: 60px;
		height: 24px;
		background: #13B8EE;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #13B8EE;
		color: white;
		font-size: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.road-info .info-box .title-box .tips-end {
		width: 60px;
		height: 24px;
		background: #999;
		border-radius: 4px 4px 4px 4px;
		border: 1px solid #999;
		color: white;
		font-size: 12px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	
	.road-info .info-box .descs {
		color: #666666;
		margin-top: 24px;
		overflow: hidden;
		text-overflow: ellipsis;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
	}

	.road-info .info-box .time {
		margin-top: 32px;
		display: flex;
		align-items: center;
	}

	.road-info .info-box .time .icon {
		width: 38px;
		height: 38px;
		border: 1px solid #E6E6E6;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}

	.road-info .info-box .time .time-info {
		margin-left: 10px;
	}

	.road-info .info-box .company {
		margin-top: 16px;
		display: flex;
		align-items: center;
	}

	.road-info .info-box .company .icon {
		width: 38px;
		height: 38px;
		border: 1px solid #E6E6E6;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 4px;
	}

	.road-info .info-box .company .company-info {
		margin-left: 10px;
	}



	.act-item {
		margin-top: 15px;
		width: 570px;
		height: 300px;
		border-radius: 8px;
	}

	.act-item .bg {
		width: 570px;
		height: 300px;
		position: absolute;
		padding: 50px;
		border-radius: 8px;
		background-color: rgba(28, 44, 129, 0.5);
	}

	.act-item .title {
		font-size: 22px;
		color: white;
		font-weight: 400;
		border-bottom: 1px solid rgba(255, 255, 255, 0.5);
		padding-bottom: 16px;
		margin-top: 160px;
	}

	.act-item .title span {
		border-bottom: 1px solid white;
		padding-bottom: 21px;
	}

	.head-bg {
		width: 100%;
		height: 300px;
	}

	.head-bg h2 {
		font-size: 36px;
		padding-top: 142px;
	}

	.head-bg p {
		font-size: 24px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/roadshow/roadshow.vue